/* eslint-disable */
// Import Routes
import Routes from './routes.js'
import store from '@/store/index'
import config from './../config/customer.api'
import { PAGES } from './shared/routes.constants.js'

const LOG_NAVIGATION_EVENTS = true
function log () {
  if (!LOG_NAVIGATION_EVENTS) {
    return
  }
  if(typeof(console) !== 'undefined') {
    console.log.apply(console, arguments);
  }
}

function openLoginModalIfUserIsStillOnMainPage (view, lastKnownUrl) {
  let currentUrl = view.url
  log('afterBackNavigation')
  log(' -> view.url', currentUrl)
  log(' -> lastKnown', lastKnownUrl)

  // f7 router.preroute is not the best hook, as it returns 'url = #null' for both back navigation (when actual page is not null)
  // and for going back to root page (launch-screen.page)
  // We only want to open login screen on launch-screen


  if (currentUrl !== lastKnownUrl) {
    // This means that url has changed asynchronously at some point and we do not longer want to open login modal
    // Previous page has been loaded in the background
    log('Previous page has been loaded in the background, skip opening of login modal')
    return
  }

  if (currentUrl !== '#null') {
    return
  }

  // When we are here - launch screen is probably already visible to user for 400ms, and we need to open login modal

  if (!store.state.login.isLoginScreenOpen) {
    // There is caveat with this: calling `closeModal` and then, after some time `loginScreen('#login-screen')`
    // will happen out of order, and results in login screen visible only for a short period and collapse immediately
    // looks like modal commands in f7 are queued and executes in not-deterministic time
    window.f7.loginScreen('#login-screen');
  }
}

class RouterHooks {
  static preroute(view, options) {
    // const store = view.container.__vue__.$store;
    // store.state.common.dealerIsDeleted
    // console.log("PREROUTE", store.state.common.dealerIsDeleted);

    log(JSON.stringify(options)) 
      //console.log('Route to ' + options.url); 
      let nextUrlDefined = typeof options.url !== 'undefined'
/*       if(options.isBack == true && options.preloadOnly!=true &&  nextUrlDefined==false){
        if(view.url == 'inventory' || view.url == 'video-message')
          options.url = 'home'; 
      } */
      var regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

      if (regex.test(view.url)===true && options.isBack) {
        view.router.load({url: 'home' })
        return true
      }
      if(options.isBack && view.url =='inventory')
        {options.url = 'home'}

      const refData = store.state.recommendFriend.newReferralData
      if(options.url === PAGES.RecommendAFriendReferral && refData && !options.isBack){
        store.dispatch("recommendFriend/clearNewReferralData")
      }

      var hid2 = view.history.findIndex(x => x == "inventory")
      if(hid2>0){
        view.history.splice(hid2,1); 
      }  
      var hid1 = view.history.findIndex(x => x == "home" )
      if(hid1>0){
        view.history.splice(hid1,1); 
      }   
      var hid12 = view.history.findIndex(x => x == "video-message" )
      if(hid12>0){
        view.history.splice(hid12,1); 
      }   

    return true
  }
} 
// Init Framework7 by passing parameters here
let f7Config = {
  pushStateSeparator: '',
  root: '#app',
  pushStateRoot:config.sourceUrl+"/",
  /* Uncomment to enable Material theme: */
  material: true,
  routes: Routes,
  pushState: true,
  cache: false,
  domCache: false,
  // swipePanel: 'right',
  preroute: RouterHooks.preroute,

}
export default f7Config



// WEBPACK FOOTER //
// ./scripts/src/f7-config.js